const environment = {
  production: false,
  url: 'https://qtool.test.digilacca.com.ar/qtool',
  // url: 'http://192.168.48.227:9012/qtool',
  //url: '/api'
};

export { environment };
